import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "common/locales";
import {
  AccessibleUser,
  selectAccessibleUserById,
  useAppSelector,
} from "model";

interface ConfirmCancellationDialogProps {
  confirmDialogOpen: boolean;
  closeDialog: () => void;
  onConfirmSubmit: () => Promise<void>;
  onConfirmCancel: () => void;
  associatedFarmer: string;
  submitDisabled: boolean;
}

export default function ConfirmSubmitDialog(
  props: ConfirmCancellationDialogProps
) {
  const {
    onConfirmSubmit,
    onConfirmCancel,
    confirmDialogOpen,
    closeDialog,
    associatedFarmer,
    submitDisabled,
  } = props;
  const { t } = useTranslation();

  const user = useAppSelector((state) => state.user.details);

  const accessibleUser: AccessibleUser | undefined = useAppSelector((state) =>
    selectAccessibleUserById(state, associatedFarmer)
  );

  return (
    <Dialog
      open={confirmDialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={"xs"}
    >
      <DialogTitle id="alert-dialog-title">
        {t("upload.file.confirm.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {accessibleUser?.guid !== user?.guid &&
            t("confirm.sumbit.file.upload.warning.text")}
          {accessibleUser?.guid !== user?.guid &&
            (accessibleUser?.name ?? accessibleUser?.mail)}
        </DialogContentText>
        <DialogContentText id="alert-dialog-description">
          {t("confirm.sumbit.file.upload.general.text")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onConfirmCancel();
            closeDialog();
          }}
          color="secondary"
          disabled={submitDisabled}
        >
          {t("cancel.file.upload.submit.label")}
        </Button>
        <Button
          onClick={async () => {
            await onConfirmSubmit();
            closeDialog();
          }}
          color="primary"
          autoFocus
          disabled={submitDisabled}
        >
          {t("confirm.file.upload.submit.label")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
